import {
  SurveyMonkeyLink,
  Molenda2007Link,
  Morrison2013Link,
} from '../../common/links'

const data = {
  titleMain: 'Instructional Design and Assessment Report',
  titleSecondary: 'Powerpoint Prototype of Instructional Unit',
  courseNumber: 'EDET 722',
  projectLink:
    'https://drive.google.com/file/d/1FRd_fYC5QRT7ghHWgg1y32o4FqK5cwb1/view?usp=sharing',
  projectLink2:
    'https://drive.google.com/file/d/1YMeJCmked5xtGodeobTTM1_X55L7_nUv/view?usp=sharing',
  standardName: 'AECT 2 – Content Pedagogy ',
  standardSummary:
    'Candidates develop as reflective practitioners able to demonstrate effective implementation of educational technologies and processes based on contemporary content and pedagogy.',
  contextAndConditions:
    'During the Fall 2019 Instructional Design and Assessment (EDET 722) course with Dr. Karen Qian, we applied instructional design and assessment principles to the development and formative testing of instruction in integrated technology-based contexts.',
  scope:
    'As indicated in the first artifact link, I followed a systematic instructional design process in order to produce a self-paced instructional module (second artifact link) on “The 60 Year Curriculum” for my employer, SC AHEC.',
  role:
    'I completed this project by myself and served as the primary subject matter expert, instructional designer, and developer. I did recruit seven SC AHEC staff to participate in the needs assessment survey in order to better understand the target audience.',
  instructionalDesign: `Following ADDIE (${Molenda2007Link}) and MRK (${Morrison2013Link}) instructional design models, I completed a front-end analysis, which included a need analysis to identify the needs for instruction, a goal analysis that identified the goals for the instruction based on the needs analysis, a learner analysis that describes the characteristics of the target audience (SC AHEC staff), and a contextual analysis that described the instructional context and performance context. I then completed a topical task analysis, developed performance objectives and assessment items, and designed the instructional strategy plan. Finally, I developed the interactive, self-paced e-learning module and a formative evaluation plan, which included evaluation instruments, methods, and intent for data analysis and reporting.`,
  performanceIndicator: [
    {
      title: 'Creating',
      indicator:
        'Candidates apply content pedagogy to create appropriate applications of processes and technologies to improve learning and performance outcomes.',
      implementation:
        'Following MRK instructional design model, I created “The 60 Year Curriculum” self-paced, e-learning module.',
    },
    {
      title: 'Using',
      indicator:
        'Candidates implement appropriate educational technologies and processes based on appropriate content pedagogy.',
      implementation: `I used ${SurveyMonkeyLink} to develop the needs assessment survey and PowerPoint to develop the instructional module.`,
    },
    {
      title: 'Assessing/Evaluating',
      indicator:
        'Candidates demonstrate an inquiry process that assesses the adequacy of learning and evaluates the instruction and implementation of educational technologies and processes grounded in reflective practice.',
      implementation:
        'For the formative evaluation plan, I developed five evaluation instruments: SME notes form, observation notes form, interview protocol, attitude survey, and learner performance assessment in order to evaluate the effectiveness of the instructional module.',
    },
    {
      title: 'Managing',
      indicator:
        'Candidates manage appropriate technological processes and resources to provide supportive learning communities, create flexible and diverse learning environments, and develop and demonstrate appropriate content pedagogy.',
      implementation:
        'Utilizing PowerPoint features, I created an interactive module which is self-paced in order to provide flexibility for the learner.',
    },
    {
      title: 'Ethics',
      indicator:
        'Candidates design and select media, technology, and processes that emphasize the diversity of our society as a multicultural community.',
      implementation:
        'I developed a specific section within the instructional module which addresses generational differences and similarities which affect learning abilities and preferences.',
    },
  ],
  reflection:
    'Since this was the first time I had written a comprehensive instructional design plan, the Instructional Design and Assessment Report demonstrates an initial understanding of the process. Looking back now, I could have been more descriptive in my front-end analysis, specifically with how data was collected, analyzed, and results displayed. As I progressed in the course, I added more details in my documentation and am pleased with the Instructional Strategy Plan and Formative Evaluation Plan. In addition, many of the PowerPoint features which are used to create a self-paced, interactive module were new to me. If I used this technology in the future, I would add audio to the slides in order to reduce the number of words and provide more engagement.',
}

export default data
